
const main = () => {
    const invalidElements = document.querySelectorAll('input._invalid, select._invalid, textarea._invalid');
    if(invalidElements.length === 0) return
    
    invalidElements.forEach(element => {
        element.addEventListener('input', () => {
            if (element.value) {
                element.classList.remove('_invalid');
            }
        });
    });
}

export default main;